import * as actions from './activityTypes'

const initialState = {
    data: []
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.SET_ACTIVITYS:
            return {
                ...state,
                data: action.payload
            }
        default:
            return state;
    }
}
export default reducer;